import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import store from './store/RepoProject';
import { Button, Checkbox, Input, Modal, Skeleton, Typography } from 'antd';
import RepoAccordion from './components/RepoAccordion';
import { SearchOutlined } from '@ant-design/icons';
import { dataAccess } from '../../core/dataAccess/dataAccess';

import styles from './styles/repoList.module.scss';

const ACTIVE_ONLY_HINT = 'Last commit is not later than 2 weeks';

const RepoListView = observer(() => {
  useEffect(() => {
    store.setRepoProjectList().then();
  }, []);

  if (store.repoProjectList === null) return <Skeleton />;
  
  return (
    <>
      {store.filteredRepoProjectList.map((repository: any) => (
        <RepoAccordion
          key={repository.id.toString()}
          id={repository.id}
          name={repository.name}
          type={repository.type}
          url={repository.url}
          projectsNum={repository.projects_num}
          activeProjectsNum={repository.active_projects_num}
          successDate={repository.last_processed_date}
          lastError={repository.last_error}
          projectErrors={repository.project_errors_num}
          isDisabled={repository.disabled}
          projects={repository.projects}
          store={store}
        />
      ))}
    </>
  );
});

function RepoList() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [log, setLog] = useState('');

  const hideModal = () => setIsModalOpen(false);

  const handleLogClick = async () => {
    const [ { lastLog } ] = await dataAccess.getCrawlerLastLog();
    setLog(lastLog);
    setIsModalOpen(true);
  };

  return (
    <div className={styles.repoListWrapper}>
      <div className={styles.repoListsSubHeader}>
        <Input
          style={{ width: 300 }}
          variant="filled"
          placeholder="Search by project name"
          value={store.searchQuery}
          suffix={<SearchOutlined />}
          onChange={(e) => store.setSearchQuery(e.target.value)}
        />
        <Checkbox
          title={ACTIVE_ONLY_HINT}
          checked={store.filters.activeOnly}
          onChange={(e) => store.setActiveOnly(e.target.checked)}
        >
          <span title={ACTIVE_ONLY_HINT}>Show active projects only</span>
        </Checkbox>
        <Checkbox
          checked={store.filters.errorsOnly}
          onChange={(e) => store.setErrorsOnly(e.target.checked)}
        >
          <span>Show only projects with error</span>
        </Checkbox>
        {/* ToDo: add this checkbox when enable/disable feature is implemented
        <Checkbox
          checked={store.filters.hideDisabled}
          onChange={(e) => store.setHideDisabled(e.target.checked)}
        >
          Hide disabled
        </Checkbox> */}
        <Button type={'link'} style={{ marginLeft: 'auto' }} onClick={handleLogClick}>
          Show crawler log
        </Button>
      </div>

      <div className={styles.repoListContent}>
        <RepoListView />
        <Modal
          title="Crawler last run log"
          style={{ top: 20 }}
          styles={{
            body: {
              overflowY: 'auto',
              maxHeight: 'calc(100vh - 200px)',
              backgroundColor: 'black',
              color: 'white',
            },
          }}
          width={'70vw'}
          cancelButtonProps={{ style: { display: 'none' } }}
          open={isModalOpen}
          onOk={hideModal}
          onCancel={hideModal}
        >
          <Typography.Paragraph style={{ whiteSpace: 'pre-wrap', color:'white', paddingLeft: 10, paddingRight: 10 }}>
            {log}
          </Typography.Paragraph>
        </Modal>
      </div>
    </div>
  );
}

export default observer(RepoList);
